module.exports = __webpack_public_path__ + "img/iconDownloadWhite.31790026.svg";